import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronDown, faChevronUp} from "@fortawesome/free-solid-svg-icons";
import _ from "../Trans";

const defaultSeeMoreText = _('See more');
const defaultSeePreviousText = _('Previous')

const LessButton = function({requestPrevious, seePreviousText}) {
    if(seePreviousText === null || seePreviousText === undefined) {
        seePreviousText = defaultSeePreviousText;
    }
    return (
        <span onClick={requestPrevious} className="link"><FontAwesomeIcon icon={faChevronUp}/> {seePreviousText} <FontAwesomeIcon icon={faChevronUp}/></span>
    )
}

const MoreButton = function({requestMore, seeMoreText}) {
    if(seeMoreText === null || seeMoreText === undefined) {
        seeMoreText = defaultSeeMoreText;
    }
    return (
        <span onClick={requestMore} className="link"><FontAwesomeIcon icon={faChevronDown}/> {seeMoreText} <FontAwesomeIcon icon={faChevronDown}/></span>
    )
}

export {MoreButton, LessButton};